/**
 * Helper class for authentication stuff.
 */
import {connect} from "react-redux";

class AuthHelper {

  _permissionsUsed = [];
  _permissionsChecked = {};

  constructor(permissionsUsed, permissionsToCheck) {
    if (permissionsUsed) {
      this.permissionsUsed = permissionsUsed;
    }
    if (permissionsToCheck) {
      this.checkAllPermissionsUsed(permissionsToCheck);
    }
  }

  set permissionsUsed(value) {
    this._permissionsUsed = value;
    this._permissionsChecked = {};
  };

  addPermissions(permission) {
    this._permissionsUsed.push(permission);
  }

  get permissionsUsed() {
    return this._permissionsUsed;
  }

  get permissionsChecked() {
    return this._permissionsChecked;
  }

  checkAllPermissionsUsed(permissionsToCheck) {
    this._permissionsChecked = {};
    this._permissionsUsed.forEach(permissionUsed => {
      this._permissionsChecked[permissionUsed] = AuthHelper.checkPermissions(permissionsToCheck, permissionUsed);
    });

    return this._permissionsChecked;
  }

  checkPermission(permission) {
    return this._permissionsChecked.hasOwnProperty(permission) && this._permissionsChecked[permission];
  }

  somePermission(permissions) {
    return permissions.some(permission => this.checkPermission(permission));
  }

  /**
   * List of routes that can be accessed by guests (without login).
   *
   * @returns {[string]}
   */
  static get publicRoutes() {
    return ["/login"];
  }

  /**
   * Check if the current user is authenticated (logged in).
   *
   * @returns {boolean}
   */
  static get isAuthenticated() {
    const token = AuthHelper.token;
    return (token && token.length);
  }

  /**
   * Get user's authentication token.
   */
  static get token() {
    return localStorage.getItem("token");
  }

  static checkAuthenticationOnEnter = (location, action, b, c) => {
    console.log(location);
    console.log(action);
    console.log(b, c);

    return true;
  };

  static checkPermissions = (permissions, location) => {
    let locations = location;
    if (!(location instanceof Array)) {
      locations = [location];
    }

    return locations.every(location => permissions.some(permission => location.indexOf(permission) !== -1));
  };

  static hasPermission = (permissionsSource, permissionsTarget) => {
    return permissionsSource.some(permission => AuthHelper.checkPermissions(permissionsTarget, permission));
  }
}

// const mapStateToProps = (state) => {
//   return {
//     user: state.users.data,
//     token: state.users.token,
//     isLoggedIn: state.users.isLoggedIn
//   };
// };

export default /*connect(mapStateToProps)*/(AuthHelper);



// WEBPACK FOOTER //
// ./utils/AuthHelper.js